import React from "react";
import { IonItem, IonLabel, IonAccordion } from "@ionic/react";

export interface Props {}

const FinishingYourQuiz: React.FC<Props> = () => {
  return (
    <IonAccordion value="FinishingYourQuiz">
      <IonItem slot="header" color="light">
        <IonLabel>Finishing Your Quiz</IonLabel>
      </IonItem>
      <div className="ion-padding" slot="content">
        <p>
          It is really important to Finalise Results at the completion of your
          quiz. The app will not let you log out without acknowledging that the
          results have not been finalised. All details of your quiz are stored
          constantly as you progress. Therefore, if you close the app without
          finalising, you can simply log back in and complete the Finalise
          Results step. If you try to perform the Finalise function twice you
          will be reminded that you have already submitted your results data. To
          finish your quiz complete a two-step process from the Home Menu,
        </p>
        <ol>
          <li>Select the Cast icon and choose Stop,</li>
          <li>Click on Log Out from the Home Menu.</li>
        </ol>
        <p>This ensures that cached data does not remain on your tv screen.</p>
      </div>
    </IonAccordion>
  );
};

export default FinishingYourQuiz;
